/* eslint-disable react/display-name */
import React, { useMemo } from 'react';

export const useHtmlParser = (htmlString: string) => {
  const parsedHtml = useMemo(() => ({ __html: htmlString }), [htmlString]);

  const HtmlComponent = React.memo(({ className }: { className?: string }) => (
    <p dangerouslySetInnerHTML={parsedHtml} className={className} />
  ));

  return { HtmlComponent };
};
